import { Button, Card, Dropdown, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { showAlert } from "../../../reducer/alertSlice";
import { hideConfirm, showConfirm } from "../../../reducer/confirmSlice";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Loading from "./Loading";

const BtnRemoveMemo = styled.div`
    position: absolute;
    right: 0;
    top: 0;
`;
export default function BranchMemo() {
    const {branchId} = useParams();
    const location = useLocation();
    const textareaRef = useRef();
    const dispatch = useDispatch();
    const [memoArr, setMemoArr] = useState([]);
    const [sort, setSort] = useState("최신 순");
    const loginInfo = useSelector(state => state.login);

    const {data, isError, isLoading, isRefetching, refetch, error} = useQuery({
        queryKey: ['branchMemo'],
        queryFn: () => {
            return axios("/branch/memo/list", {
                method: "POST",
                data: {
                    branchId: branchId, 
                    order: sort == "최신 순" ? "desc" : "asc"
                }
            }).then((result) => {
                if (result.data.code != "0") {
                    throw new Error(result);
                }

                return result.data;
            })
        },
        enabled: false,
    });

    const addMemo = useMutation({
        mutationKey: ['addMemo'],
        mutationFn: () => axios("/branch/memo/add", {
            method: "POST",
            data: {
                branchId: branchId,
                content: textareaRef.current.value
            }
        }).then(result => {
            if (result.data.code == "0") {
                textareaRef.current.value = "";
                dispatch(showAlert({
                    msg: "등록되었습니다",
                }));
                refetch();
            }

            return result.data
        })
    });

    const removeMemo = useMutation({
        mutationKey: ['removeMemo'],
        mutationFn: (id) => axios("/branch/memo/delete/" + id, {
            method: "DELETE",
        }).then(result => {
            if (result.status == "204") {
                dispatch(showAlert({
                    msg: "삭제되었습니다",
                }));
                refetch();
            } else {
                throw new Error();
            }
            
            return result.data;
        }).catch((e) => {
            dispatch(showAlert({
                msg: "처리 도중 오류가 발생했습니다.",
            }));
            console.log(e);
        })
    });

    useEffect(() => {
        if (data) {
            setMemoArr(data.data);
        }
    },[data]);

    useEffect(() => {
        refetch();
    },[sort]);

    useEffect(() => {
        refetch();
    },[location]);

    if (isLoading || isRefetching) {
        return <Loading />
    }
    if (isError) {
        return <div>{error.response.data.msg.ko}</div>
    }
    return (
        <div>
            <Card>
                <Card.Header>
                    <Card.Title>
                        메모 입력
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <Form.Control ref={textareaRef} as="textarea" style={{height: "180px", resize: "none"}} placeholder="내용을 입력하세요" />
                </Card.Body>
                <Card.Footer className="d-flex justify-content-end">
                    <Button onClick={() => {
                        if (textareaRef.current.value.trim() == "") {
                            dispatch(showAlert({
                                msg: "내용을 입력해주세요."
                            }))
                        } else {
                            addMemo.mutate();
                        }
                    }}>작성</Button>
                </Card.Footer>
            </Card>

            <Card className="mt-3">
                <Card.Header>
                    <Dropdown onSelect={(value) => {
                        setSort(value);
                    }}>
                        <Dropdown.Toggle style={{width: "150px"}} variant="white">
                            {sort}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="최신 순">최신순</Dropdown.Item>
                            <Dropdown.Item eventKey="오래된 순">오래된순</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Card.Header>
                <Card.Body className="custom-scroll" style={{maxHeight: "400px", overflow: "auto"}}>
                    
                    {
                    isError ?
                    <p>데이터를 불러오는 도중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.</p>
                    :
                    <ul className="step step-icon-xs">
                        {
                            memoArr &&
                            memoArr.length == 0 ? <p className="px-3 text-secondary">등록된 메모가 없습니다.</p>
                            :
                            memoArr.map((val, idx) => {
                                return (
                                    <li className="step-item" key={val.memmoId}>
                                        <div className="step-content-wrapper">
                                            <span className="step-icon step-icon-soft-secondary step-icon-pseudo"></span>
                                            <div className="step-content">
                                                {
                                                    !val.isDelete &&
                                                    (loginInfo.admin.id == val.adminId) &&
                                                    <BtnRemoveMemo>
                                                        <Button variant="outline-danger" onClick={() => {
                                                            dispatch(showConfirm({
                                                                msg: "정말 삭제하시겠어요?",
                                                                btnText: "삭제",
                                                                func: () => {
                                                                    dispatch(hideConfirm());
                                                                    removeMemo.mutate(val.memmoId);
                                                                }
                                                            }));
                                                        }}>삭제</Button>
                                                    </BtnRemoveMemo>
                                                }
                                                <h4 className="fw-bold">
                                                    {val.writer}
                                                </h4>
                                                <div className="small text-secondary mt-2">{val.registerTime}</div>
                                                <p className={val.isDelete ? "step-text mt-3 opacity-50" : "step-text text-black mt-3"}>
                                                    {
                                                    val.content
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}